import { useMutation } from '@tanstack/react-query'
import { supabase } from '../api'

const deletePost = async (
  id: number | string,
) => {
  const { error: deleteHashtagsError } = await supabase
    .from('hashtags_posts')
    .delete()
    .eq('post_id', id);

  if (deleteHashtagsError) {
    throw new Error(deleteHashtagsError.message);
  }

  const { data, error } = await supabase
    .from('posts')
    .delete()
    .eq('id', id);

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useDeletePost(
  id: number | string,
) {
  return useMutation(() => deletePost(id), {
    onSuccess: async (res) => res,
  })
}
